import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9999 1.15039C10.6558 1.14842 8.36371 1.84173 6.41367 3.14262C4.46363 4.44351 2.94323 6.29353 2.0448 8.45866C1.14637 10.6238 0.910269 13.0067 1.36637 15.3061C1.82248 17.6054 2.95029 19.7178 4.60715 21.3761C6.264 23.0343 8.37545 24.1639 10.6744 24.622C12.9733 25.08 15.3565 24.8459 17.5224 23.9493C19.6883 23.0527 21.5396 21.5339 22.8421 19.5849C24.1447 17.636 24.8399 15.3445 24.8399 13.0004C24.8373 9.86012 23.5893 6.84908 21.3697 4.62763C19.1502 2.40619 16.1402 1.15569 12.9999 1.15039ZM12.9999 24.1504C10.8062 24.1523 8.66118 23.5043 6.83558 22.288C5.00998 21.0717 3.5857 19.3418 2.74259 17.3166C1.89947 15.2914 1.67533 13.0618 2.09846 10.9094C2.52159 8.75688 3.57301 6.77805 5.11998 5.22272C6.66694 3.66738 8.64007 2.60529 10.7902 2.17056C12.9404 1.73582 15.1711 1.94793 17.2008 2.78011C19.2305 3.61228 20.9681 5.0272 22.1943 6.84621C23.4204 8.66522 24.08 10.8068 24.0899 13.0004C24.0873 15.9418 22.9183 18.762 20.8394 20.8428C18.7605 22.9236 15.9413 24.0951 12.9999 24.1004V24.1504Z",
			fill: "#DC562E",
			stroke: "#DC562E",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.71 7.14062H12.23V15.9306H13.71V7.14062Z",
			fill: "#DC562E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8501 17.3408H12.1001V19.1908H13.8501V17.3408Z",
			fill: "#DC562E"
		})
	]
});
export default SvgError;
